import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PassdataService } from '../services/passdata.service';

@Component({
  standalone: false,
  selector: 'invd-settled-exchanges-container',
  templateUrl: './settled-exchanges-container.component.html',
  styleUrls: ['./settled-exchanges-container.component.scss'],
})
export class SettledExchangesContainerComponent {
  private router = inject(Router);
  private passDataService = inject(PassdataService);
}
